var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('h2',[_vm._v(_vm._s(_vm.$t('message.pageNotFound'))+" !")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }